// Generat automat din README.md
import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  icon: Icon,
  loading = false,
  disabled = false,
  fullWidth = false,
  ...props 
}) => {
  const variants = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    ghost: 'btn-ghost'
  };

  const sizes = {
    sm: 'btn-sm',
    md: '',
    lg: 'btn-lg'
  };

  const widthClass = fullWidth ? 'w-full' : 'mobile-full sm:w-auto';

  const baseClass = `inline-flex items-center justify-center font-medium transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed touch-target ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;

  return (
    <button 
      className={baseClass} 
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <div className="w-3 h-3 sm:w-4 sm:h-4 border-2 border-current border-t-transparent rounded-full animate-spin flex-shrink-0" />
      )}
      {Icon && !loading && <Icon className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />}
      <span className="truncate">{children}</span>
    </button>
  );
};

export default Button;
